import clsx from 'clsx';
import React, { Fragment, useState } from 'react';

import MessageModal from '@components/MessageModal';
import { OurTeamProps } from '@utils/aboutInterfaces';

import Group from './Group';

const OurTeam = ({ canSendMessage, team }: OurTeamProps) => {
  const [messageUser, setMessageUser] = useState(null);
  const [currentGroupSelected, setCurrentGroupSelected] = useState<string>('Editorial');
  const numberOfTabs = team.length - 1;

  return (
    <article className="mt-48 md:mt-80">
      <h2 className="my-0 mb-56 border-0 border-b border-solid border-grayscale-beige pb-24 font-suisse-works text-headline-md">
        Our Team
      </h2>
      <div
        className={
          'mx-0 flex min-w-[260px] max-w-full gap-56 border-0 border-b border-solid border-black '
        }
        role="tablist"
      >
        {team.map((group, index) => (
          <Fragment key={group.name}>
            <div
              onClick={() => {
                setCurrentGroupSelected(group.name);
              }}
              className={clsx(
                'cursor-pointer font-suisse-intl-mono text-caption-lg hover:text-primary-magenta',
                {
                  'active pointer-events-none border-0 border-b-[12px] border-solid border-primary-magenta':
                    currentGroupSelected === group.name,
                }
              )}
            >
              {group.name}
            </div>
            {numberOfTabs > index && <div className="-mb-3 w-[1px] rotate-[-30deg] bg-black" />}
          </Fragment>
        ))}
      </div>
      <div className="flex flex-col justify-start font-suisse-intl-mono text-caption-lg">
        {team
          .filter((group) => group.name === currentGroupSelected)
          .map((filteredGroup) => (
            <Group
              key={filteredGroup.name}
              group={filteredGroup}
              setMessageUser={setMessageUser}
              canSendMessage={canSendMessage}
            />
          ))}
      </div>
      {canSendMessage && <MessageModal user={messageUser} onClose={() => setMessageUser(null)} />}
    </article>
  );
};

export default OurTeam;
